import React, { useState } from 'react';
import moment from 'moment-jalaali';
import styled from 'styled-components';
import { Button } from 'components/elements';
import { colors, rgba } from 'settings/style';
import { zDateDetails, zMonth, zYear } from '@polgozar/utils';
import { jalaliMonth } from 'utils/jalaliMonth';
import { zreYearFromGregorian } from 'utils/zreYearFromGregorian';
import { Link } from 'react-router-dom';

const ZCalendar = ({ changeDate = true }) => {
  const [dateIdx, setDate] = useState(0);
  const date = moment().add(dateIdx, 'day');
  const dateData = zDateDetails(date, 'week');
  const fasliMonth = zMonth(date);
  const magianMonth = jalaliMonth(date);
  const fasliYear = zYear(date);
  const magianYear = zreYearFromGregorian(date);
  /** Middle: Zarvāni — jD, Jalali month, ZRE year (Gregorian + 1738). */
  const magianLine = `${date.format('jD')} ${magianMonth.name.en} ${magianYear}`;
  /** Bottom: Fasli — day name, month, Fasli era year (zYear, e.g. 3764). */
  const fasliLabel = `${dateData?.name?.en || ''} o ${fasliMonth.name.en} ${fasliYear}`.trim();

  return (
    <CalendarCont changeDate={changeDate}>
      {changeDate && (
        <div className="dateController">
          <Button onClick={() => setDate(dateIdx - 1)} leftIcon="icon-chevron-left" type="link" />
          <Button onClick={() => setDate(0)} type="primary" ghost>
            Today
          </Button>
          <Button onClick={() => setDate(dateIdx + 1)} rightIcon="icon-chevron-right" type="link" />
        </div>
      )}

      <div className="contentCont">
        <Link to="/calendar">
          <p>{date.format('dddd, MMMM D YYYY')}</p>
          <p className="magianLine">{magianLine}</p>
          <div className="dayRow fasliLine">
            <span>{fasliLabel}</span>
            {dateData.isNabor && (
              <span className="naborDay">
                (Nabor{' '}
                <span role="img" aria-label="nabor image">
                  🌱
                </span>
                )
              </span>
            )}
          </div>
          {!!dateData.events && <p>{dateData.events.map((e) => e.en)}</p>}
        </Link>
      </div>
    </CalendarCont>
  );
};
export default ZCalendar;

const CalendarCont = styled.div<{ changeDate: boolean }>`
  margin: 0 auto;
  text-align: center;

  .dateController {
    margin-bottom: 1em;
  }
  .contentCont {
    background-color: ${(props) => (props.changeDate ? colors.grey900 : '#182230')};
    border: 2px solid ${colors.accent};
    border-radius: 10px;
    padding: 1rem;
    cursor: pointer;
    p {
      line-height: 2rem;
      color: white;
    }
    transition: all 0.5s;
    &:hover {
      background-color: ${rgba(colors.accent, 0.08)};
    }
  }
  .naborDay {
    color: ${colors.success};
  }

  .dayRow {
    line-height: 2rem;
    color: white;
  }
`;
